import styled from 'styled-components';

export const FilteredText = styled.h2`
    padding-bottom: 1rem;
    margin-bottom: 2rem;
    border-bottom: 5px double black;

`